import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useUpdateUserInfo() {
  const updateUserInfo = async ({
    data,
    userId,
  }: {
    data: any;
    userId: number;
  }) => {
    const response = await http.put(`/user/${userId}`, data);
    return response.data;
  };

  return useMutation({
    mutationFn: updateUserInfo,
  });
}
